const socialLinks = [
  {
    url: 'https://www.facebook.com/casa.it',
    altText: 'Casa.it - Facebook',
    target: '_blank',
    rel: 'me',
    class: 'fb',
  },
  {
    url: 'https://twitter.com/casapuntoit',
    altText: 'Casa.it - Twitter',
    target: '_blank',
    rel: 'me',
    class: 'tw',
  },
  {
    url: 'https://www.youtube.com/user/casaitchannel',
    altText: 'Casa.it - Youtube',
    target: '_blank',
    rel: 'me',
    class: 'yt',
  },
  {
    url: 'https://www.linkedin.com/company/casa-it',
    altText: 'Casa.it - LinkedIn',
    target: '_blank',
    rel: 'me',
    class: 'in',
  },
  {
    url: 'https://www.instagram.com/casapuntoit/',
    altText: 'Casa.it - Instagram',
    target: '_blank',
    rel: 'me',
    class: 'is',
  },
  {
    url: 'https://t.me/casapuntoit',
    altText: 'Casa.it - Telegram',
    target: '_blank',
    rel: 'me',
    class: 'tg',
  },
];
export default socialLinks;
